<div class="lightContent">
  <div class="headingPage">
    <h2 class="">Select Element</h2>
  </div>

  <div class="listing" pageId="pick-element" allApi="all_elements"
    [showPagination]="true" searchApi="search_elements"
    metaApi="element_meta" search_label="Search Elements..."
    [isPickEnabled]="true" [typesToPick]="elementType"
    (sendIdToParentfn)="elementSelected($event)"
    [multipleStories]="chooseMultiple"
    [RelatedStorySearch]="true"
    [storyIdArray]="elementIdList"></div>

    <div class="right" *ngIf="chooseMultiple">
      <button type="button" name="discard" class="discard gray" (click)="closePopup()">Close</button>
      <button type="button" name="save" class="save blue" (click)="elementsSelected()" [disabled]="elementIdList && elementIdList.length < 1">Choose {{elementIdList.length}} Elements</button>
    </div>
</div>
